// Create a channel shared by all tabs of the same origin
const reloadChannel = new BroadcastChannel('app-reload-channel');

export function broadcastReload() {
  reloadChannel.postMessage({ type: 'RELOAD' });
}

// Every tab listens for the reload signal
export function listenForReloadSignal() {
  reloadChannel.onmessage = (event) => {
    if (event.data?.type === 'RELOAD') {
      window.location.reload();
    }
  };
}
